import PropTypes from "prop-types";

const ExpandSingleFoodName = ({ food }) => {
    const checkCharacterNumbers = (text) => {
        return Number(text.length);
    };

    return (
        <>
            <div className="food-column-item food-name">
                <div
                    className={`title ${
                        checkCharacterNumbers(food.Title) > 25
                            ? "smallText"
                            : ""
                    }`}
                >
                    <p>{food.Title}</p>
                </div>
            </div>
        </>
    );
};

ExpandSingleFoodName.propTypes = {
    food: PropTypes.object,
};

export default ExpandSingleFoodName;
